import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  driving_score_count: number;
}

const DrivingScoresCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "Driving Scores",
  accessorFn: (row) => row.driving_score_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default DrivingScoresCol;
